import { Fragment } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import UserUtils from 'src/services/utils/UserUtils';
import NotificationItem from '../../components/NotificationItem';
import { roles } from 'src/pages/Admin/administration/user-management/data';

const Handler = ({
    notifications,
    workspace,
    user,
    t
}) => {
    const userUtils = new UserUtils();

    const handleTranslateOnType = (notification) => {
		const notificationType = notification.message_type;
		const secondaryTaskId = notification.data?.secondaryTaskId;
		const secondaryCaseId = notification.data?.secondaryId;
		const secondaryRiskId = notification.data?.secondaryRiskId;
		const riskRate = notification.data?.riskRate;
		const isIncident =notification.data?.questionnaire === "data_breach_incident" ? true : null ;
		const isRequest =notification.data?.questionnaire === "data_subject_request" ? true : null ;
		const isSoftware =notification.data?.software ? true : null ;
        const SoftwareID =notification.data?.secondaryId;

		switch (notificationType) {
            case "new_chat": {
                return t("You have received a new live chat request");
            }
            case "new_comment": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {isSoftware ? t("Your software has a new comment") :
                            isRequest  ? t("Your DSR has a new comment") :
                            isIncident ? t('Your incident has a new comment') :
                            t("Your report has a new comment")}
                        </span>

                        <span style={{ display: 'block' }}>
                            {isRequest ? t('Request ID') :
                            isIncident ? t('Incident ID') :
                            isSoftware ? t('Software ID') :
                            t('Report ID')
                            }: {isSoftware ? SoftwareID : secondaryCaseId }
                        </span>
                    </Fragment>
                );
            }
            case "new_internal_comment": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {isSoftware ? t("Your software has a new internal comment") :
                            isRequest  ? t("Your DSR has a new internal comment") :
                            isIncident ? t('Your incident has a new internal comment') :
                            t("Your report has a new internal comment")}
                        </span>

                        <span style={{ display: 'block' }}>
                            {isRequest ? t('Request ID') :
                            isIncident ? t('Incident ID') :
                            isSoftware ? t('Software ID') :
                            t('Report ID')
                            }: {isSoftware ? SoftwareID : secondaryCaseId }
                        </span>
                    </Fragment>
                );
            }
            case "open": {
                return  <>{isSoftware ? t("Your software has been received and read") :
                isRequest  ? t("Your DSR has been received and read") :
                isIncident ? t("Your incident has been received and read") :
                t("Your report has been received and read")}</>
            }
            case "in_progress": {
                return (
                    <Fragment>
                        {isSoftware ? t("Your software status changed to In Progress") :
                        isRequest  ? t("Your DSR status changed to In Progress") :
                        isIncident ? t("Your incident status changed to In Progress") :
                        t("Your report status changed to In Progress")}
                    </Fragment>
                );
            }
            
            case "closed": {
                return (
                    <Fragment>
                        {isSoftware ? t("Your software status changed to Closed") :
                        isRequest  ? t("Your DSR status changed to Closed") :
                        isIncident ? t("Your incident status changed to Closed") :
                        t("Your report status changed to Closed")}
                    </Fragment>
                );
            }
            case "deleted": {
                return (
                    <Fragment>
                        {isSoftware ? t("Your software has been deleted") :
                        isRequest  ? t("Your DSR has been deleted") :
                        isIncident ? t("Your incident has been deleted") :
                        t("Your report has been deleted")}
                    </Fragment>
                );
            }
            case "pending_delete": {
                return (
                    <Fragment>
                        {isSoftware ? t("Your software has been deleted") :
                        isRequest  ? t("Your DSR has been deleted") :
                        isIncident ? t("Your incident has been deleted") :
                        t("Your report has been deleted")}
                    </Fragment>
                );
            }
            case "new": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                        {isSoftware ? t("Your software has been submitted") :
                        isRequest  ? t("Your report has been submitted") :
                        isIncident ? t("Your incident has been submitted") :
                        t("Your request or report has been submitted.")}
                        </span>
                        {isSoftware ? SoftwareID : secondaryCaseId !==undefined 
                        ? "\n" + t("ID") + ": " + secondaryCaseId
                        : ""}
                    </Fragment>
                );
            }
            case "new_case_reported": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                        {isSoftware ? t("You have received a new software") :
                        isRequest  ? t("You have received a new DSR") :
                        isIncident ? t("You have received a new incident") :
                        t("You have received a new report")}
                        </span>
                        <span style={{ display: 'block' }}>
                                {isRequest ? t('Request ID') :
                                isIncident ? t('Incident ID') :
                                isSoftware ? t('Software ID') :
                                t('Report ID')
                                }: {isSoftware ? SoftwareID : secondaryCaseId }
                            </span>
                    </Fragment>
                );
            }
            case "assigned": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                        {isSoftware ? t("Your software has been assigned to an analyst") :
                        isRequest  ? t("Your DSR has been assigned to an analyst") :
                        isIncident ? t("Your incident has been assigned to an analyst") :
                        t("Your report has been assigned to an analyst")}
                        </span>
                    </Fragment>
                );
            }
            case "software_assigned":{
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("A new software has been assigned to you.")}
                        </span>
                        <span className='d-block'>
                            {`${t('Software ID')}: ${secondaryCaseId}`}
                        </span>
                    </Fragment>
                )
            }
            case "received_news": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("New adverse news has been received for your software.")}
                        </span>
                        <span className='d-block'>
                            {`${t('Software ID')}: ${secondaryCaseId}`}
                        </span>
                    </Fragment>
                )
            }
            case "new_case_assigned": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                        {isSoftware ? t("A software was assigned to you") :
                        isRequest  ? t("A DSR was assigned to you") :
                        isIncident ? t("An incident was assigned to you") :
                        t("A report was assigned to you")}
                        </span>
                        <span style={{ display: 'block' }}>
                                {isRequest ? t('Request ID') :
                                isIncident ? t('Incident ID') :
                                isSoftware ? t('Software ID') :
                                t('Report ID')
                                }: {isSoftware ? SoftwareID : secondaryCaseId }
                            </span>
                    </Fragment>
                );
            }
            case "new_attachment": {
                return (
                    <Fragment>
                        {isSoftware ? t("You have received an update on your software") :
                        isRequest  ? t("You have received an update on your DSR") :
                        isIncident ? t("You have received an update on your incident") :
                        t("You have received an update on your report")}
                    </Fragment>
                );
            }
            case "case_had_been_read": {
                return (
                    <Fragment>
                        {isSoftware ? t("Your software has been read") :
                        isRequest  ? t("Your DSR has been read") :
                        isIncident ? t("Your incident has been read") :
                        t("Your report has been read")}
                    </Fragment>
                );
            }
            case "case_in_progress": {
                return (
                    <Fragment>
                        {isSoftware ? t("An Analyst is working on your software") :
                        isRequest  ? t("An Analyst is working on your DSR") :
                        isIncident ? t("An Analyst is working on your incident") :
                        t("An Analyst is working on your report")}
                    </Fragment>
                );
            }
            case "case_had_been_closed": {
                return (
                    <Fragment>
                        {isSoftware ? t("Your software has been closed") :
                        isRequest  ? t("Your DSR has been closed") :
                        isIncident ? t("Your incident has been closed") :
                        t("Your report has been closed")}
                    </Fragment>
                );
            }
            case "sip_system_update": {
                return "Smart Integrity Platform " + notification?.data?.caseId
                ? t("Report update")
                : t("System update");
            }
            case "risk_assign": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("A new risk has been assigned to you.")}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryRiskId}
                        </span>
                    </Fragment>
                );
            }
            case "tom_before_revision": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("The deadline for the tom revision is soon.")}
                        </span>
                    </Fragment>
                );
            }
            case "tom_assigned": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("The TOM is assigned to you.")}
                        </span>
                    </Fragment>
                );
            }
            case "risk_comment": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("A comment was added to your risk.")}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryRiskId}
                        </span>
                    </Fragment>
                );
            }
            case 'upcoming_recurring_task': {
                const { 
                    secondaryTaskId
                } = notification.data;
				return (
					<Fragment>
                        <span className='d-block'>
                            <i
                                className="ri-repeat-2-line text-info me-1 font-size-16 align-middle"
                            />
                            {t('You have a recurring task approaching its due time. Please review it in your tasks.')}
                        </span>
						<span className='d-block'>
							{t('ID')}: {secondaryTaskId}
						</span>
					</Fragment>
				);
            }
            case "new_task_created": {
                return (
                    <Fragment>
                        {notification.data?.isRecurring ? (
                            <span className='d-block'>
                                <i
                                    className="ri-repeat-2-line text-info me-1 font-size-16 align-middle"
                                />
                                {t('A new recurring task has been assigned to you.')}
                            </span>
                        ) : (
                            <span className='d-block'>
                                {t('A new task has been assigned to you.')}
                            </span>
                        )}
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryTaskId}
                        </span>
                    </Fragment>
                );
            }
            case "task_status_new": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("The status of your task has been changed.")}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryTaskId}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("New status")}: {t("New")}
                        </span>
                    </Fragment>
                );
            }
            case "task_status_in_progress": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("The status of your task has been changed.")}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryTaskId}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("New status")}: {t("In Progress")}
                        </span>
                    </Fragment>
                );
            }
            case "task_status_review": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("The status of your task has been changed.")}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryTaskId}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("New status")}: {t("Review")}
                        </span>
                    </Fragment>
                );
            }
            case "task_status_delete": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("The status of your task has been changed.")}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryTaskId}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("New status")}: {t("Deleted")}
                        </span>
                    </Fragment>
                );
            }
            case "task_status_close": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("The status of your task has been changed.")}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryTaskId}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("New status")}: {t("Closed")}
                        </span>
                    </Fragment>
                );
            }
            case "task_priority_low": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("The priority of your task has been changed.")}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryTaskId}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("New priority")}: {t("Low")}
                        </span>
                    </Fragment>
                );
            }
            case "task_priority_medium":
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("The priority of your task has been changed.")}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryTaskId}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("New priority")}: {t("Medium")}
                        </span>
                    </Fragment>
                );
            case "task_priority_high":
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("The priority of your task has been changed.")}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryTaskId}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("New priority")}: {t("High")}
                        </span>
                    </Fragment>
                );
            case "task_comment":
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("A comment was added to your task")}.
                        </span>
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryTaskId}
                        </span>
                    </Fragment>
                );
            case "task_before_overdue": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("The deadline for the task is soon.")}
                        </span>
                        <span style={{ display: "block" }}>
                            {notification?.data?.secondaryTaskId
                                ? "\n" +
                                t("Task ID") +
                                ": " +
                                notification.data.secondaryTaskId
                                : notification?.data?.taskId
                                ? "\n" +
                                t("Task ID") +
                                ": " +
                                notification?.data?.taskId
                                : ""}
                        </span>
                    </Fragment>
                );
            }
            case "new_task": {
                return (
                    <span style={{ display: "block" }}>
                        {t("You created a new task")}.
                    </span>
                );
            }
            case "task_change_deadline": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("Deadline of your task was changed")}.
                        </span>
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryTaskId}
                        </span>
                    </Fragment>
                );
            }
            case "task_change_start_date": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("Start date of your task was changed")}.
                        </span>
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryTaskId}
                        </span>
                    </Fragment>
                );
            }
            case "task_change_description": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("The description of your task has been changed.")}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("ID")}: {secondaryTaskId}
                        </span>
                    </Fragment>
                );
            }
            case "task_overdue": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("The deadline for your task is today.")}
                        </span>
                        <span style={{ display: "block" }}>
                        {notification?.data?.secondaryTaskId
                            ? "\n" +
                            t("Task ID") +
                            ": " +
                            notification.data.secondaryTaskId
                            : notification?.data?.taskId
                            ? "\n" +
                            t("Task ID") +
                            ": " +
                            notification?.data?.taskId
                            : ""}
                        </span>
                    </Fragment>
                );
            }
            case "risk_rating": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                            {t("The rating of your risk has been changed.")}
                        </span>
                        <span style={{ display: "block" }}>
                            {t("New rating")}: {riskRate}
                        </span>
                    </Fragment>
                );
            }
            case "risk_change_description": {
                return (
                    <span style={{ display: "block" }}>
                        {t("Description of your risk was changed")}.
                    </span>
                );
            }
            case "status_update": {
                return t(
                    "The status of your case has been updated: {{status}}"
                );
            }
            case "readonly_access": {
                return (
                    <Fragment>
                        {isSoftware ? t("You have read-only access to a software.") :
                            isRequest  ? t("You have read-only access to a DSR.") :
                            isIncident ? t("You have read-only access to an incident.") :
                            t("You have read-only access to a case.")}
                            +
                            <span style={{ display: 'block' }}>
                            {
                            t('ID')
                            }: {isSoftware ? SoftwareID : secondaryCaseId }
                        </span>
                    </Fragment> 
                );
            }
            case "comment_mention": {
                return (
                    <Fragment>
                        <span style={{ display: "block" }}>
                        {t("You have been mentioned in a comment")}.
                        </span>
                        {isRequest ? t('Request ID') :
                    isIncident ? t('Incident ID') :
                    isSoftware ? t('Software ID') :
                        t('Report ID')
                    }: {isSoftware ? SoftwareID : secondaryCaseId }
                    </Fragment>
                );
            }
            case "task_owner_role_removed": {
                return (
                    <span style={{ display: "block" }}>
                        {t("Your task owner role has been removed by the admin")}
                        .
                    </span>
                );
            }
            case "task_owner_role_added": {
                return (
                    <span style={{ display: "block" }}>
                        {t("You have been assigned to the Task Owner role")}.
                    </span>
                );
            }
            case "high_dpia_risk_created": {
                return (
                    <>
                        <span style={{ display: "block" }}>
                            {t("The risk assessment indicates a high risk level. Please proceed to complete the Data Protection Impact Assessment")}.
                        </span>
                        {SoftwareID ? 
                            <span style={{ display: 'block' }}>
                                {t('Software ID') 
                                }: {SoftwareID}
                            </span>
                        : ''}
                    </>
                );
            }
            case 'in_active_user': {
                const { name, role } = notification?.data;

                return (
                    <Fragment>
                        <span className='d-block'>
                            {t("A user was deactivated.")}
                        </span>
                        <span className='d-block'>
                            {`${t("Name")}: ${name}`}
                        </span>
                        <span>
                            {`${t("Role")}: ${t(roles[role]?.label)}`}
                        </span>
                    </Fragment>
                )
            }
            case 'active_user': {
                const { name, role} = notification?.data;

                return (
                    <Fragment>
                        <span className='d-block'>
                            {t("A user was activated.")}
                        </span>
                        <span className='d-block'>
                            {`${t("Name")}: ${name}`}
                        </span>
                        <span>
                            {`${t("Role")}: ${t(roles[role]?.label)}`}
                        </span>
                    </Fragment>
                )
            }
            case 'add_user': {
                const { name, role} = notification?.data;
                return (
                    <Fragment>
                        <span className='d-block'>
                            {t("A new user was added to your SIP.")}
                        </span>
                        <span className='d-block'>
                            {`${t("Name")}: ${name}`}
                        </span>
                        <span>
                            {`${t("Role")}: ${t(roles[role]?.label)}`}
                        </span>
                    </Fragment>
                )
            }
            case 'delete_user': {
                const { name, role} = notification?.data;

                return (
                    <Fragment>
                        <span className='d-block'>
                            {t("A user was deleted.")}
                        </span>
                        <span className='d-block'>
                            {`${t("Name")}: ${name}`}
                        </span>
                        <span>
                            {`${t("Role")}: ${t(roles[role]?.label)}`}
                        </span>
                    </Fragment>
                )
            }
            case 'user_limitation_over': {
                return <span>{t("You have reached your max license limit. Please reach out to the SIP support.")}</span>
            }
            case 'new_legal_entity_is_added_manually':{
                const { 
                    entity_title
                } = notification.data;

                return (
                    <Fragment>
						<span className='d-block'>
                            {`${t('A new entity has been added to the SIP.')} ${t('Name')}: ${entity_title}`}
                        </span>
					</Fragment>
                )
            }
            case 'new_legal_entity_list_uploaded': {
                return (
                    <span className='d-block'>
                        {t('Congrats! You have uploaded a new entity list.')}
                    </span>
                )
            }
            default: {
                return t(notificationType);
            }
        }
	}

	const handleRenderNotification = (notification, index) => {
		let link = '#';
		if (typeof notification.id !== "undefined") {
            if (workspace === "third_party_workspace") {
                switch (notification.message_type) {
                    case "new_chat": {
                            link = "livechat";
                        break;
                    }
                    case "new_task_created":
                    case "task_status_new":
                    case "task_status_in_progress":
                    case "task_status_review":
                    case "task_status_close":
                    case "task_status_delete":
                    case "task_priority_low":
                    case "task_priority_medium":
                    case "task_priority_high":
                    case "task_comment":
                    case "task_overdue":
                    case "task_change_deadline":
                    case "task_change_start_date":
                    case "task_change_description":
                    case "upcoming_recurring_task":
                    case "task_before_overdue": {
                        if (userUtils.isTaskOwner(user)) {
                            link = `tasks/${notification.data.taskId}`;
                        } else {
                            link = `report/task/${notification.data.taskId}`;
                        }
                        break;
                    }
                    case "risk_assign":
                    case "risk_comment":
                    case "risk_rating":
                    case "risk_change_description": {
                            link = `report/risk/${notification.data.riskId}`;
                        break;
                    }
                    case "tom_before_revision": {
                        link = `data-protection/tom?tab=tom`;
                        break;
                    }
                    case "tom_assigned": {
                        link = `data-protection/tom?tab=tom`;
                        break;
                    }
                    default: {
                            link = `report/detail`;
                        break;
                    }
                }
            } 
            else {
                switch (notification.message_type) {
                    case "new_chat": {
                            link = "livechat";
                        break;
                    }
                    case "task_owner_role_removed":
                    case "task_owner_role_added":
                    case "new_task_created":
                    case "task_status_new":
                    case "task_status_in_progress":
                    case "task_status_review":
                    case "task_status_close":
                    case "task_status_delete":
                    case "task_priority_low":
                    case "task_priority_medium":
                    case "task_priority_high":
                    case "task_comment":
                    case "task_overdue":
                    case "task_change_deadline":
                    case "task_change_start_date":
                    case "task_change_description":
                    case "upcoming_recurring_task":
                    case "task_before_overdue": {
                        if (userUtils.isTaskOwner(user)) {
                            link = `data-protection/tasks/${notification.data.taskId}`;
                        }
                        else{
                            if (notification.data?.questionnaire === "data_subject_request") {
                                if (notification.data?.taskId) {
                                    link = `data-protection/data-subject-request/details/${notification.data.caseId}?tab=task-management&taskId=${notification.data?.taskId}`;
                                } else {
                                    link = `data-protection/data-subject-request/details/${notification.data.caseId}?tab=task-management`;
                                }
                            }
                            else if (
                                notification.data?.questionnaire === "data_breach_incident"
                            ) {
                                if (notification.data?.taskId) {
                                    link = `data-protection/incident-register/details/${notification.data.caseId}?tab=task-management&taskId=${notification.data?.taskId}`;
                                } else {
                                    link = `data-protection/incident-register/details/${notification.data.caseId}?tab=task-management`;
                                }
                            }
                            else if (notification.data?.software) {
                                if (notification.data?.taskId) {
                                    link = `data-protection/softwares/${notification.data.software}?tab=task-management&taskId=${notification.data?.taskId}`;
                                } else {
                                    link = `data-protection/softwares/${notification.data.software}?tab=task-management`;
                                }
                            } else {
                                link = `data-protection/tasks/${notification.data.taskId}/details`;
                            }
                        }
                        break;
                    }
                    case "risk_assign": {
                        if (notification.data?.questionnaire === "data_breach_incident") {
                            if (notification.data?.riskId) {
                                link = `data-protection/incident-register/details/${notification.data.caseId}?tab=risk-assessment&riskId=${notification.data?.riskId}`;
                            } else {
                                link = `data-protection/incident-register/details/${notification.data.caseId}?tab=risk-assessment`;
                            }
                        }
                        else if (notification.data?.software) {
                            if (notification.data?.riskId) {
                                link = `data-protection/softwares/${notification.data.software}?tab=risk-assessment&riskId=${notification.data?.riskId}`;
                            } 
                            else
                                link = `data-protection/softwares/${notification.data.software}?tab=risk-assessment`;
                            } 
                        else {
                            link = `report/task/${notification.data.riskId}`;
                        }
                        break;
                    }
                    case "tom_before_revision": {
                        link = `data-protection/tom?tab=tom`;
                        break;
                    }
                    case "tom_assigned": {
                        link = `data-protection/tom?tab=tom`;
                        break;
                    }

                    case "risk_comment":
                    case "risk_rating":
                    case "risk_change_description": {
                        if (notification.data?.questionnaire === "data_subject_request") {
                            link = `data-protection/data-subject-request/details/${notification.data.caseId}?tab=risk-assessment`;
                        }
                        else if (
                            notification.data?.questionnaire === "data_breach_incident"
                        ) {
                            link = `data-protection/incident-register/details/${notification.data.caseId}?tab=risk-assessment`;
                        }
                        else if (notification.data?.software) {
                            link = `data-protection/softwares/${notification.data.software}?tab=risk-assessment`;
                        } else {
                            link = `report/task/${notification.data.riskId}`;
                        }
                        break;
                    }
                    case "new_comment":{
                        if (notification.data?.questionnaire === "data_subject_request") {
                            link = `data-protection/data-subject-request/details/${notification.data.caseId}?tab=messages`;
                        }
                        else if (
                            notification.data?.questionnaire === "data_breach_incident"
                        ) {
                            link = `data-protection/incident-register/details/${notification.data.caseId}?tab=messages`;
                        }
                        else if (notification.data?.software) {
                            link = `data-protection/softwares/${notification.data.software}?tab=messages`;
                        }
                        break;
                    }
                    case "comment_mention":
                    case "new_internal_comment": {
                        if (notification.data?.questionnaire === "data_subject_request") {
                            link = `data-protection/data-subject-request/details/${notification.data.caseId}?tab=internal-comments`;
                        }
                        else if (
                            notification.data?.questionnaire === "data_breach_incident"
                        ) {
                            link = `data-protection/incident-register/details/${notification.data.caseId}?tab=internal-comments`;
                        }
                        else if (notification.data?.software) {
                            link = `data-protection/softwares/${notification.data.software}?tab=internal-comments`;
                        }
                        break;
                    }
                    case "high_dpia_risk_created": {
                        if (notification.data?.software) {
                            link = `data-protection/softwares/${notification.data.software}?tab=dpia`;
                        }
                        break;
                    }

                    case "new_attachment":
                    case "open":
                    case "in_progress":
                    case "case_had_been_closed":
                    case "closed":
                    case "deleted":
                    case "pending_delete":
                    case "case_had_been_deleted":
                    case "new":
                    case "new_case_reported":
                    case "assigned":
                        if (notification.data?.questionnaire === "data_subject_request") {
                            link = `data-protection/data-subject-request/details/${notification.data.caseId}`;
                        }
                        else if (
                            notification.data?.questionnaire === "data_breach_incident"
                        ) {
                            link = `data-protection/incident-register/details/${notification.data.caseId}`;
                        }
                        else if (notification.data?.software) {
                            link = `data-protection/softwares/${notification.data.software}?tab=basic-information`;
                        }
                        break;  
                    case "software_assigned":
                        link = `data-protection/softwares/${notification.data.software}?tab=basic-information`;
                        break;
                    case "received_news":
                        link = `data-protection/softwares/${notification.data.software}?tab=monitoring`;
                        break;
                    case "new_case_assigned":
                    case "new_contact_request":
                    case "new_demo_request":
                    case "readonly_access": {
                        if (notification.data?.questionnaire === "data_subject_request") {
                            link = `data-protection/data-subject-request/details/${notification.data.caseId}`;
                        }
                        else if (
                            notification.data?.questionnaire === "data_breach_incident"
                        ) {
                            link = `data-protection/incident-register/details/${notification.data.caseId}`;
                        }
                        else if (notification.data?.software) {
                            link = `data-protection/softwares/${notification.data.software}`;
                        }
                        break;
                    }
                    case 'in_active_user': 
                    case 'add_user': 
                    case 'active_user':
                        link = `data-protection/administration/users/${notification.data.id}/edit`
                    break;
                    case 'delete_user':
                    case 'user_limitation_over':
                        link = `data-protection/administration/users`
                    break;
                    case 'new_legal_entity_is_added_manually':
                        link = `entity-management/entities/${notification.data.entity_id}/detail`;
                    break;
                    case 'new_legal_entity_list_uploaded':
                        link = 'entity-management/entities';
                    break;
                    default: {
                        link = `report/detail`;
                        break;
                    }
                }
            }
        }

        return (
            <NotificationItem 
                index={index}
                link={link} 
                notification={notification}
                content={handleTranslateOnType(notification)}
                onClick={() => {
                    localStorage.setItem('taskId', notification.data.taskId ? notification.data.taskId : '');
                    localStorage.setItem('riskId', notification.data.riskId ? notification.data.riskId : '');
                    localStorage.setItem('caseId', notification.data.caseId);

                    if (notification.data.secondaryId) {
                        localStorage.setItem('secondaryCaseId', notification.data.secondaryId);
                    }
                }}
            />
        );
	};

    return (
        <>
            {(notifications?.list || []).map((notification, index) => {
                return (
                    <div key={notification.id}
                        style={{
                            animationName: notification.hasMotion ? 'newNotificationAnimation' : '',
                            animationDuration: '0.6s',
                            animationIterationCount: 1,
                            overflow: 'hidden',
                            transition: 'opacity 0.3s ease 0s, max-height 0.3s ease 0.3s',
                            maxHeight: notification.isRead ? '0px' : '1000px',
							opacity: notification.isRead ? '0' : '1',
                        }}
                    >
                        {handleRenderNotification(notification, index)}
                    </div>
                );
            })}
        </>
    );
}

const mapStatetoProps = (state) => {
	return {
        organization    :   state.Organization,
        user            :   state.Login?.user,
        token           :   state.Login?.token,
		notifications   :   state.AppNotification,
        modules         :   state.Modules,
        workspace       :   state.Workspace
	};
};

export default connect(
    mapStatetoProps, null
)(withNamespaces()(
    Handler
));